import Vue from 'vue'
import Router from 'vue-router'
import layout from '../components/layout/index.vue'
import store from '../store/index'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      // redirect: '/layout/index',
      component: () => import('../views/home/index.vue')
    },
    {
      path: '/login',
      name: '登陆',
      component: () => import('../views/loginRela/index.vue')
    },
    {
      path: '/layout',
      component: layout,
      children: [
        {
          path: 'index',
          name: '首页',
          component: () => import('@/views/home/index.vue')
        },
        {
          path: 'collectionHall',
          name: '集采大厅',
          redirect: '/layout/collectionHall/list',
          component: () => import('@/views/collectionHall/index.vue'),
          children: [
            {
              path: 'list',
              name: '集采大厅列表',
              component: () => import('@/views/collectionHall/list.vue')
            },
            {
              path: 'detail',
              name: '集采大厅详情',
              component: () => import('@/views/collectionHall/detail.vue')
            },
          ]
        },
        {
          path: 'notice',
          name: '通知公告',
          component: () => import('@/views/notice/index.vue')
        },
        {
          path: 'aboutUs',
          name: '关于我们',
          component: () => import('@/views/aboutUs/index.vue')
        },
        {
          path: 'helpCenter',
          name: '帮助中心',
          component:() => import('@/views/helpCenter/index.vue')
        },
        {
          path: 'userCenter',
          name: '用户中心',
          component: () => import('@/views/userCenter/index.vue')
        }
      ]
    }
  ]
})
function handleTabs(path) {
  store.state.tabs = ['首页']
  if(path.indexOf('collectionHall') > -1) {
    store.state.tabs[1] = '集采大厅'
    return
  }
  if(path.indexOf('notice') > -1) {
    store.state.tabs[1] = '通知公告'
    return
  }
  if(path.indexOf('aboutUs') > -1) {
    store.state.tabs[1] = '关于我们'
    return
  }
  if(path.indexOf('helpCenter') > -1) {
    store.state.tabs[1] = '帮助中心'
    return
  }
  if(path.indexOf('userCenter') > -1) {
    store.state.tabs[1] = '用户中心'
    return
  }
}
router.beforeEach((from, to, next) => {
  handleTabs(from.path)
  store.state.tabs = store.state.tabs.concat([])
  next()
})
router.afterEach((to,from,next) => {
  document.querySelector('body').scrollTop = 0
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js